import React from 'react';
import ChecklistElement from './ChecklistElementModel';
import EditorType from '../../../Enums/EditorType';
import type { JSX } from 'react';
import { AutocompleteInput } from 'shouldve-been-mui';

class UserChecklistElement extends ChecklistElement {

    private _currentAsDefault: boolean;
    private _roleId: string | null;

    public constructor(elementId: string, name: string, itemNumber: string | null, sortNumber: number, currentAsDefault: boolean, roleId: string | null) {

        super(elementId, name, itemNumber, sortNumber, EditorType.USER);
        this._currentAsDefault = currentAsDefault;
        this._roleId = roleId;
    }

    public get currentAsDefault(): boolean {
        return this._currentAsDefault;
    }

    public set currentAsDefault(value: boolean) {
        this._currentAsDefault = value;
    }

    public get roleId(): string | null {
        return this._roleId;
    }

    public set roleId(value: string | null) {
        this._roleId = value;
    }

    public buildFormElement(value: string, onChange: (value: string) => Promise<void>, userAutocompleteOptions: { label: string, id: string, disabled: boolean }[], screenWidth: number): JSX.Element {

        const currentUserAutocompleteOptions: { label: string, id: string, disabled: boolean }[] = userAutocompleteOptions;

        if (value !== '' && !userAutocompleteOptions.map((option: { label: string, id: string, disabled: boolean }) => option.id).includes(value)) { //allows removed options to still be there until changed
            currentUserAutocompleteOptions.push({
                label: value,
                id: value,
                disabled: true,
            });
        }

        return (
            <React.Fragment key={this.elementId}>
                <AutocompleteInput
                    labelText={this.name}
                    value={value}
                    options={currentUserAutocompleteOptions}
                    onChange={onChange}
                    width={Math.min(screenWidth * 0.8, 500)}
                    dense={true}
                    limit={1000}
                />
                <br />
                <br />
            </React.Fragment>
        );
    }
}

export default UserChecklistElement;